/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { Button, FlexContainer, H2, Icon, Stack, Text, TextLink, StackProps } from "@carrotfertility/carotene"
import { Link, useHistory } from "react-router-dom"
import { getAccountDeletionPath } from "components/talk-to-carrot/util/talkToCarrotMolecules"
import { Paths } from "utils/Paths"
import { FormattedMessage } from "react-intl"
import { useGetPrivacyNoticeUrl } from "services/common-urls/useGetPrivacyNoticeUrl"

function Back(props: StackProps): JSX.Element {
  return (
    <Link to={"/account"}>
      <Stack
        sx={{
          display: "inline-flex",
          ":hover": {
            opacity: "50%"
          }
        }}
        {...props}
        alignItems="center"
        spacing="medium"
        direction="row"
      >
        <Icon color="carrotOrange" size="tiny" sx={{ transform: "rotate(180deg)" }} name="rightCarrotSmall" />
        <Text>
          <FormattedMessage defaultMessage="Back" />
        </Text>
      </Stack>
    </Link>
  )
}

/**
 * This component intentionally doesn't use SingleColumnLayout due to some funky height related issues.
 * Since this page is mobile app only this should not be an issue.
 */
export function AccountDeletionPage(): JSX.Element {
  const history = useHistory()
  const privacyNoticeUrl = useGetPrivacyNoticeUrl()
  return (
    <FlexContainer direction="column" height="100%" paddingLeftRight="18px" paddingTopBottom="huge">
      <Back stack="large" />
      <Stack spacing="small">
        <H2>
          <FormattedMessage defaultMessage="About account deletion" />
        </H2>
        <Text>
          <FormattedMessage defaultMessage="Once you send a request, we'll reach out within 30 business days to let you know that your deletion is complete or to provide an update if it might take longer to fulfill." />
        </Text>
        <Text>
          <FormattedMessage defaultMessage="While your account will be closed, certain data may be retained to support legitimate business interests and/or legal obligations." />
        </Text>
        <Text>
          <FormattedMessage
            defaultMessage="For more information about how we use and protect your personal information, please visit our <link>Privacy Notice</link>."
            values={{
              link: (linkContent) => (
                <TextLink size="medium" target="_blank" href={privacyNoticeUrl}>
                  {linkContent}
                </TextLink>
              )
            }}
          />
        </Text>
      </Stack>
      <FlexContainer alignItems="end" height="100%" justifyContent="center">
        <Button
          data-testid="continue-to-account-deletion"
          onClick={() => history.push(getAccountDeletionPath({ baseUrl: Paths.TALK_TO_CARROT }))}
        >
          <FormattedMessage defaultMessage="Continue to request deletion" />
        </Button>
      </FlexContainer>
    </FlexContainer>
  )
}
